import { useState } from 'react';

export default function CopyEmail({ email }: { email: string }): JSX.Element {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000);
    } catch (err) {
      console.error('Error al copiar:', err);
    }
  };

  return (
    <span
      onClick={handleCopy}
      style={{ color: copied ? 'var(--hardcode-primary-color)' : 'inherit' }}
      className="email-value"
    >
      {email}
    </span>
  );
}
